import { combineReducers } from 'redux-immutable'

import sidebarReducer from './sidebar'
import authReducer from './auth'
import lobReducer from './lob'
import employeeReducer from './employee'
import employeeLevelsReducer from './employee-levels'
import departmentReducer from './department'
import divisionReducer from './division'
import positionReducer from './position'
import teamReducer from './team'
import companyReducer from './company'
import masterDataReducer from './master-data'
import modalReducer from './modal'
import confidentialReducer from './confidential'
import standardPriceReducer from './standard-price'
import leaveRequestReducer from './leave-request'
import compensateRequestReducer from './compensate-request'
import publicHolidayReducer from './public-holiday'
import leaveEntitlementReducer from './leave-entitlement'
import leaveTypeReducer from './leave-type'
import leaveGenerationReducer from './leave-generation'
import reportReducer from './report'
import projectInformationReducer from './project-information'
import clientMasterReducer from './client'
import timesheetReducer from './timesheet'
import subcontractCostReducer from './subcontract-cost'
import standardCostPriceReducer from './standard-cost-price'
import efficiencyReducer from './efficiency-resource'
import ppsReducer from './project-profit-sheet'
import teamCalendarReducer from './team-calendar'
import saleProductReducer from './sale-product'
import headerReducer from './header'
import accountingReducer from './accounting-dashboard'
import projectCodeReducer from './project-code'
import consentManagementReducer from './consent-management'
import consentLogReducer from './consent-log'

import * as pps_report from '../pages/report/project-profit-sheet'
import * as billingplan_report from '../pages/report/billing-plan'
import * as summarytimesheet_report from '../pages/report/summary-timesheet'

export default combineReducers({
  sidebar: sidebarReducer,
  auth: authReducer,
  lob: lobReducer,
  employee: employeeReducer,
  employeeLevels: employeeLevelsReducer,
  department: departmentReducer,
  division: divisionReducer,
  position: positionReducer,
  team: teamReducer,
  company: companyReducer,
  masterData: masterDataReducer,
  modal: modalReducer,
  confidential: confidentialReducer,
  standardPrice: standardPriceReducer,
  leaveRequest: leaveRequestReducer,
  compensateRequest: compensateRequestReducer,
  publicHoliday: publicHolidayReducer,
  leaveEntitlement: leaveEntitlementReducer,
  leaveType: leaveTypeReducer,
  leaveGeneration: leaveGenerationReducer,
  report: reportReducer,
  projectInformation: projectInformationReducer,
  client: clientMasterReducer,
  timesheet: timesheetReducer,
  subcontractCost: subcontractCostReducer,
  standardCostPrice: standardCostPriceReducer,
  efficiency: efficiencyReducer,
  pps: ppsReducer,
  teamCalendar: teamCalendarReducer,
  saleProduct: saleProductReducer,
  header: headerReducer,
  accounting: accountingReducer,
  projectCode: projectCodeReducer,
  consentManagement: consentManagementReducer, 
  consentLog: consentLogReducer,

  [pps_report.constants.REDUCER_NAME]: pps_report.reducer,
  [billingplan_report.constants.REDUCER_NAME]: billingplan_report.reducer,
  [summarytimesheet_report.constants.REDUCER_NAME]: summarytimesheet_report.reducer,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js